
import { Box } from "@mui/material";
import { DisenioPaginas } from "../../layout";
import { useCategoriasQuery } from "../../../hooks";
import { BuscadorSoloValor, CargandoMedio, TablaCategorias } from "../../components";






export const ListadoCategoriaProductos = () => {


    const { categoriasQuery, page, termino, chagePage, chageTermino } = useCategoriasQuery()


    return (
        <DisenioPaginas titulo="Listado Categorias Productos" url="add/new/categoria">
            {(categoriasQuery.isLoading)
            ?   <CargandoMedio titulo="Cargando unidades de medida..." />
            :   <>
                <BuscadorSoloValor termino={termino} chageTermino={chageTermino} titulo='Buscar categoria...' place='Buscar x nombre...'/>
                <TablaCategorias data={categoriasQuery.data || []} chagePage={chagePage} page={page} />
                </>
            }
            <Box sx={{height:30}} />
        </DisenioPaginas>
    )

}

